import React from 'react';
import {
  useDialog,
  DialogTitleWithCloseAction,
  DialogSecondaryAction
} from '@ianesthesie-kit/redux';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  Paper
} from '@mui/material';
import { TranslatedText } from '@ianesthesie-kit/core';
import { ErrorCode } from '@/modules/error';
import { AppConfigService } from '@/config';

const toKey = (tail: string) =>
  `app.error.${ErrorCode.QUESTIONNAIRE_NOT_ASSIGNED}.${tail}`;

export const NoAssignedQuestionnaireDialog = () => {
  const { closeDialog } = useDialog();

  return (
    <Paper sx={{ p: 0, maxWidth: 500 }}>
      <DialogTitleWithCloseAction onClose={closeDialog}>
        <TranslatedText id={toKey('title')} />
      </DialogTitleWithCloseAction>
      <DialogContent>
        <DialogContentText>
          <TranslatedText id={toKey('body1')} />
          <br />
          <TranslatedText id={toKey('body2')} />
          <br />
          <TranslatedText id={toKey('body3')} />
          <br />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <DialogSecondaryAction
          component="a"
          target="_blank"
          href={AppConfigService.getInstance().getLink('support')}
          onClick={closeDialog}
        >
          <TranslatedText id="app.contactUs" />
        </DialogSecondaryAction>
        <Button onClick={closeDialog}>
          <TranslatedText id="app.close" />
        </Button>
      </DialogActions>
    </Paper>
  );
};
